/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { CustomHeader, Screen, Text } from "components"
import React, { useCallback, useEffect, useState } from "react"
import {
  ActivityIndicator,
  FlatList,
  Image,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import { TabView } from "react-native-tab-view"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import { colors } from "colors"
import { useSessionExpired } from "utils/function"
import flash from "config/flash"
import { useStores } from "models"
import moment from "moment"
import useResponsiveWidth from "components/fitSize"

import coffeeImg from "../../../../assets/coffee_animation.gif"
import expiredImg from "../../../../assets/expired-img.png"
import claimedImg from "../../../../assets/claimed-img.png"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"

import RenderHtml from "react-native-render-html"
import { useColor } from "app/theme/getThemes"
import { VoucherContainer } from "components/VoucherContainerv2"

export const ForYouScreen = () => {
  const navigation = useNavigation<any>()
  const { userStore } = useStores()

  useFocusEffect(
    useCallback(() => {
      getCoupon()
      getCouponHistory()
    }, []),
  )

  const getCoupon = async () => {
    try {
      const res = await fetch(
        `${process.env.API_URL}/api/voucher/coupon/${userStore?.id}/ongoing`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${userStore?.accessToken}`,
          },
        },
      )

      if (res.ok) {
        const response = await res.json()

        setRewards(sortVouchers(response))
      } else {
        const errorMsg = await res.json()
        console.log(errorMsg)
      }
    } catch (e) {
      flash("error", translate("errors.failedToUseVoucher"))
      console.error(e)
    }
  }

  const getCouponHistory = async () => {
    try {
      const res = await fetch(
        `${process.env.API_URL}/api/voucher/coupon/${userStore?.id}/history`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${userStore?.accessToken}`,
          },
        },
      )

      if (res.ok) {
        const response = await res.json()
        setRewardHistory(sortVouchers(response))
      } else {
        const errorMsg = await res.json()
        console.log(errorMsg)
        return []
      }
    } catch (e) {
      flash("error", translate("errors.failedToUseVoucher"))
      console.error(e)
      return []
    }
  }

  const { companyTheme } = useColor()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()
  const [reward, setRewards] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [rewardHistory, setRewardHistory] = useState([
    // {
    //   voucher_name: "Buy 5 get 1 free coffee",
    //   voucher_description: "",
    //   voucher_image: coffeeImg,
    //   totalRewards: 5,
    //   receivedReward: 3,
    // },
  ])

  const [index, setIndex] = useState(0)
  const [routes] = useState([
    { key: "first", title: "Ongoing Coupons" },
    { key: "second", title: "Expired Coupons" },
  ])

  const getVoucherStatus = (voucher) => {
    if (Number(voucher?.remaining_voucher || 0) <= 0) {
      return "Fully Redeemed"
    }
    if (voucher?.use_at) {
      return "Used"
    }
    if (moment(voucher?.voucher_expire_at).isBefore(moment())) {
      return "Expired"
    }
    if (voucher?.voucher_barcode) {
      return "Claimed"
    }
    if (moment(voucher?.start_date).isAfter(moment().subtract(7, "days"))) {
      return "New"
    }
    return "Unclaimed"
  }

  const sortVouchers = (vouchers) => {
    const ranking = {
      New: 1,
      Unclaimed: 2,
      Claimed: 3,
      Used: 4,
      Expired: 5,
      "Fully Redeemed": 6,
    }

    return vouchers.sort((a, b) => {
      const statusA = getVoucherStatus(a)
      const statusB = getVoucherStatus(b)
      return ranking[statusA] - ranking[statusB]
    })
  }

  const FirstRoute = () => <Content data={reward} type="ongoing" />

  const SecondRoute = () => <Content data={rewardHistory} type="history" />

  const Content = (props) => {
    const { data, type } = props
    const isHistory = type === "history"
    return (
      <FlatList
        contentContainerStyle={style.flatListContainer}
        data={data}
        showsVerticalScrollIndicator={false}
        ListEmptyComponent={() => {
          return (
            <View style={style.emptyContainer}>
              {isLoading ? (
                <ActivityIndicator size="large" color={companyTheme.first} />
              ) : (
                <>
                  <Image
                    source={require("../../../../assets/empty-icon.png")}
                    style={{ width: 100, height: 100, resizeMode: "contain" }}
                  />
                  <Text style={style.emptyTitle}>{translate("foryouScreen.noVoucher")}</Text>
                </>
              )}
            </View>
          )
        }}
        ListFooterComponent={() => {
          return (
            <>
              {/* {!isHistory && (
                <View style={{ alignItems: "center", marginTop: 20 }}>
                  <Text style={style.voucherDescription}>
                    {translate("foryouScreen.cannotFindVoucher")}
                  </Text>
                  <Text style={style.voucherDescription}>
                    {translate("foryouScreen.try")}{" "}
                    <Text
                      onPress={() => navigation.push("reward", { routeFrom: "history" })}
                      style={{ color: companyTheme.first }}
                    >
                      {translate("foryouScreen.searchHistory")}
                    </Text>
                  </Text>
                </View>
              )} */}
            </>
          )
        }}
        renderItem={({ item }) => {
          const regex = /<[^>]*>/gim
          const filteredDescriptionText = item?.voucher_description?.replace(regex, "")
          return (
            <View>
              <VoucherContainer
                v2
                voucherDescription={filteredDescriptionText}
                voucherImg={item?.voucher_image}
                voucherName={item?.voucher_name}
                voucherPointReq={null}
                isEmpty={Number(item?.remaining_voucher || 0) <= 0}
                isRedeemed={item?.is_redeemed}
                isExpired={
                  item?.voucher_expire_at
                    ? !moment(item.voucher_expire_at).isAfter(moment())
                    : item?.end_date
                    ? !moment(item.end_date).isAfter(moment())
                    : false
                }
                isUsed={item?.use_at}
                voucherStartDate={item?.start_date}
                voucherExpiredDate={null}
                isHistory={null}
                useAt={null}
                isPromotion={false}
                onPress={() =>
                  navigation.navigate("voucherDetail", {
                    item,
                    routeFrom: "view",
                  })
                }
                currentLocation=""
              />
            </View>
          )
        }}
      />
    )
  }

  return (
    <>
      <CustomHeader
        headerTitle={translate("foryouScreen.title")}
        height={80}
        showBackButton
        withBalls
        longHeader
      />
      <Screen>
        <View style={style.container}>
          <TabView
            swipeEnabled={false}
            animationEnabled={false}
            lazy
            renderTabBar={(props) => (
              <LinearGradient
                style={[style.linearGradient, { height: 60 }]}
                colors={[companyTheme.first, companyTheme.second]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
              >
                <TouchableOpacity style={style.headerTabBarContainer}>
                  {props.navigationState.routes.map((route, i) => {
                    return (
                      <TouchableOpacity
                        key={i}
                        onPress={() => setIndex(i)}
                        style={[style.tabBar, index === i && style.selectedTabBar]}
                      >
                        <Text
                          style={
                            index === i
                              ? { color: companyTheme.first, fontWeight: "bold" }
                              : { color: colors.white }
                          }
                        >
                          {route.title}
                        </Text>
                      </TouchableOpacity>
                    )
                  })}
                </TouchableOpacity>
              </LinearGradient>
            )}
            navigationState={{ index, routes }}
            renderScene={({ route }) => {
              switch (route.key) {
                case "first":
                  return FirstRoute()
                default:
                  return SecondRoute()
              }
            }}
            onIndexChange={setIndex}
            initialLayout={{ width }}
          />
        </View>
      </Screen>
    </>
  )
}
